import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TutorialAnimation } from './tutorial-animation.component';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [
        TutorialAnimation
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        TutorialAnimation
    ]
})
export class TutorialAnimationModule { }
